import { render, staticRenderFns } from "./_testimonies.vue?vue&type=template&id=b31a4aac"
import script from "./_testimonies.vue?vue&type=script&lang=js"
export * from "./_testimonies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports